<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box">      
      <div class="pledge-box1">   
        <div class="pledge-box1">  
          <div class="Single-list-main" v-if="dragonTigerLists.length > 0">
            <template v-for="(index, h) in dragonTigerLists" track-by="$index">
              <ul class="Single-list-box">
                <li><p class="date">交易日期</p> <p class="time">{{ h.date }}</p></li>
                <li><p class="date">成交均价(元)</p> <p class="time">{{ h.cjj | money }}</p></li>
                <li><p class="date">成交额(万元)</p> <p class="time">{{ h.summoney | money }}</p></li> 
                <li><p class="date">成交量(万股)</p> <p class="time">{{ h.quantity | money }}</p></li>   
                <li>
                  <p class="date">上榜原因</p> 
                  <p class="time">{{ h.reasonstr }}
                    <span class="nowclass">（{{ h.ratio}}%）</span>
                  </p>
                </li>
                <li>
                  <p class="date">操作</p> 
                  <p class="time links">
                    <a href="javascript:;" class="mm-top-five-btn" style="color: #0b66b7;text-decoration: underline;" v-if="showTopRow !== h.id" @click.top="viewStockTop2(h.date, h.reason, h.id)">查看交易明细</a>
                    <a href="javascript:;" class="mm-top-five-btn" style="color: #0b66b7;text-decoration: underline;" v-if="showTopRow === h.id" @click.top="hideStockTop(h.id)">关闭交易明细</a>
                  </p>
                </li>   
              </ul> 
              
              <div style="display: none;" class="top5-detail top5-detail-{{ h.id }}">
                <!-- 买入金额最大的前五名 -->
                <div class="pledge-list-box1 cop-list-box2">
                  <template v-for="(idx, item) in buyTop5">
                    <ul v-if="idx == 0">
                      <li class="active">买入金额最大的前五名</li>  
                      <li>
                        <p class="date">交易营业部名称 </p>
                        <p class="time">{{ item.unitname }}</p>
                      </li> 
                      <li>
                        <p class="date">买入金额（元）</p>
                        <p class="time">
                          <span class="infor-red" v-if="isShow(item.buy) == 1">{{ item.buy | money }}</span>
                          <span v-if="isShow(item.buy) == 3">0.00</span>
                        </p>
                      </li> 
                      <li>
                        <p class="date">卖出金额（元）</p>
                        <p class="time">
                          <span class="infor-green" v-if="isShow(item.sell) == 1">{{ item.sell | money }}</span>
                          <span v-if="isShow(item.sell) == 3">0.00</span>
                        </p>
                      </li>
                      <li>
                        <p class="date">净买入（元）</p>
                        <p class="time">
                          <span class="infor-red" v-if="isShow(item.jmr) == 1">{{ item.jmr | money }}</span>
                          <span class="infor-green" v-if="isShow(item.jmr) == 2">{{ item.jmr | money }}</span>
                          <span v-if="isShow(item.jmr) == 3">0.00</span>
                        </p>
                      </li>
                    </ul> 
                    <ul v-else> 
                      <li>
                        <p class="date">交易营业部名称 </p>
                        <p class="time">{{ item.unitname }}</p>
                      </li> 
                      <li>
                        <p class="date">买入金额（元）</p>
                        <p class="time">
                          <span class="infor-red" v-if="isShow(item.buy) == 1">{{ item.buy | money }}</span>
                          <span v-if="isShow(item.buy) == 3">0.00</span>
                        </p>
                      </li> 
                      <li>
                        <p class="date">卖出金额（元）</p>
                        <p class="time">
                          <span class="infor-green" v-if="isShow(item.sell) == 1">{{ item.sell | money }}</span>
                          <span v-if="isShow(item.sell) == 3">0.00</span>
                        </p>
                      </li>
                      <li>
                        <p class="date">净买入（元）</p>
                        <p class="time">
                          <span class="infor-red" v-if="isShow(item.jmr) == 1">{{ item.jmr | money }}</span>
                          <span class="infor-green" v-if="isShow(item.jmr) == 2">{{ item.jmr | money }}</span>
                          <span v-if="isShow(item.jmr) == 3">0.00</span>
                        </p>
                      </li>
                    </ul> 
                  </template>    
                </div> 

                <!-- 卖出金额最大的前五名 -->
                <div class="pledge-list-box1 cop-list-box2">
                  <template v-for="(idx2, h) in sellTop5">
                    <ul v-if="idx2 == 0">
                      <li class="active">卖出金额最大的前五名</li>  
                      <li><p class="date">交易营业部名称 </p><p class="time">{{ h.unitname }}</p></li> 
                      <li>
                        <p class="date">买入金额（元）</p>
                        <p class="time">
                          <span class="infor-red" v-if="isShow(h.buy) == 1">{{ h.buy | money  }}</span>
                          <span v-if="isShow(h.buy) == 3">0.00</span>
                        </p>
                      </li> 
                      <li>
                        <p class="date">卖出金额（元）</p>
                        <p class="time">
                          <span class="infor-green" v-if="isShow(h.sell) == 1">{{ h.sell | money }}</span>
                          <span v-if="isShow(h.sell) == 3">0.00</span>
                        </p>
                      </li>
                      <li>
                        <p class="date">净买入（元）</p>
                        <p class="time">
                          <span class="infor-red" v-if="isShow(h.jmr) == 1">{{ h.jmr | money }}</span>
                          <span class="infor-green" v-if="isShow(h.jmr) == 2">{{ h.jmr | money }}</span>
                          <span v-if="isShow(h.jmr) == 3">0.00</span>
                        </p>
                      </li>
                    </ul> 
                    <ul v-else> 
                      <li><p class="date">交易营业部名称 </p><p class="time">{{ h.unitname }}</p></li> 
                      <li>
                        <p class="date">买入金额（元）</p>
                        <p class="time">
                          <span class="infor-red" v-if="isShow(h.buy) == 1">{{ h.buy | money  }}</span>
                          <span v-if="isShow(h.buy) == 3">0.00</span>
                        </p>
                      </li> 
                      <li>
                        <p class="date">卖出金额（元）</p>
                        <p class="time">
                          <span class="infor-green" v-if="isShow(h.sell) == 1">{{ h.sell | money }}</span>
                          <span v-if="isShow(h.sell) == 3">0.00</span>
                        </p>
                      </li>
                      <li>
                        <p class="date">净买入（元）</p>
                        <p class="time">
                          <span class="infor-red" v-if="isShow(h.jmr) == 1">{{ h.jmr | money }}</span>
                          <span class="infor-green" v-if="isShow(h.jmr) == 2">{{ h.jmr | money }}</span>
                          <span v-if="isShow(h.jmr) == 3">0.00</span>
                        </p>
                      </li>
                    </ul> 
                  </template> 
                </div> 
              </div>
            </template>   
          </div> 

          <div class="Single-list-main" v-if="!dragonTigerLists.length && !loading"> 
            <div class="Block-trade-no">暂无数据</div>
          </div>    
        </div>  
      </div>
    </div>
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    name: 'StockTop',
    mixins: [userMix, searchMix, comSearchMix, companyMix, wxshareMix],
    data () {
      return {
        dragonTigerLists: [],
        dragSort: {
          jyrq: 0,
          cjj: 0,
          spj: 0,
          drzdf: 0,
          cje: 0,
          cjl: 0,
        },
        buyTop5: [],   //买入金额最大的前五名
        sellTop5: [],  //卖出金额最大的前五名
        showTopRow: '',   //当前显示前五大的行
      }
    },
    route: {
      data({to}) {

        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) { 
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);

          this.dragonTigerLists = [];
          this.buyTop5 = [];
          this.sellTop5 = [];
          
          this.setSelectedTab();
          this.changeDateType(7);
          this.datetype_name = '两年';
          this.getDragonTigerData();
        }

      }
    },
    methods: {
      getDragonTigerData: function() {
        this.showTopRow = '';

        let query = {};
        query.companycode = this.companycode;
        for (let key in this.dragSort) {
          this.dragSort[key] = 0;
        }

        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid
        this.loading = true;

        $.ajax({
          url: apiUrl('/V1.0.0/company/stocktops'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {

            let resource = response.data;
            for (let item of resource) {
              if (parseInt(item.quantity) !== 0) {
                item.cjj = item.summoney / item.quantity;
              } else {
                item.cjj = null;
              }
            }
            this.dragonTigerLists = resource


            // this.divMinHeight('.search_bg');

            this.$nextTick(function() {
              this.sortDragonTigerTable('date');
            });
          } else {
            alert(response.description)
          }

        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },
      // 龙虎榜表格排序
      sortDragonTigerTable: function(type) {
        if (!type) { return; }

        if (this.showTopRow != '') {
          $('.top5-detail-' + this.showTopRow).hide();
        }

        let _this = this;
        function changeIcon(key) {
          for (let k in _this.dragSort) {
            if (k == key) {
              if (_this.dragSort[k] == 1) {
                _this.dragSort[k] = 2
              } else {
                _this.dragSort[k] = 1;
              }
            } else {
              _this.dragSort[k] = 0;
            }
          }
        }

        let resource = this.dragonTigerLists;

        //交易日期
        if (type=='date') {
          if (this.dragSort.jyrq==0 || this.dragSort.jyrq==2) {
            changeIcon('jyrq');
            resource.sort((a, b) => {
              return Date.parse(b.date) - Date.parse(a.date);
            });
          } else if (this.dragSort.jyrq == 1) {
            changeIcon('jyrq');
            resource.sort((a, b) => {
              return Date.parse(a.date) - Date.parse(b.date);
            });
          }
        }

        //成交价
        if (type=='cjj') {
          if (this.dragSort.cjj==0 || this.dragSort.cjj==2) {
            changeIcon('cjj');
            resource.sort((a, b) => {
              return parseFloat(b.cjj) - parseFloat(a.cjj);
            });
          } else if (this.dragSort.cjj == 1) {
            changeIcon('cjj');
            resource.sort((a, b) => {
              return parseFloat(a.cjj) - parseFloat(b.cjj);
            });
          }
        }

        // 当日涨幅跌
        if (type=='ratio') {
          if (this.dragSort.drzdf==0 || this.dragSort.drzdf==2) {
            changeIcon('drzdf');
            resource.sort((a, b) => {
              return parseFloat(b.ratio) - parseFloat(a.ratio);
            });
          } else if (this.dragSort.drzdf == 1) {
            changeIcon('drzdf');
            resource.sort((a, b) => {
              return parseFloat(a.ratio) - parseFloat(b.ratio);
            });
          }
        }

        //成交量
        if (type=='quantity') {
          if (this.dragSort.cjl==0 || this.dragSort.cjl==2) {

            changeIcon('cjl');
            resource.sort((a, b) => {
              return parseFloat(b.quantity) - parseFloat(a.quantity);
            });

          } else if (this.dragSort.cjl == 1) {

            changeIcon('cjl');
            resource.sort((a, b) => {
              return parseFloat(a.quantity) - parseFloat(b.quantity);
            });
          }
        }

        //成交额
        if (type=='summoney') {
          if (this.dragSort.cje==0 || this.dragSort.cje==2) {

            changeIcon('cje');
            resource.sort((a, b) => {
              return parseFloat(b.summoney) - parseFloat(a.summoney);
            });
          } else if (this.dragSort.cje == 1) {

            changeIcon('cje');
            resource.sort((a, b) => {
              return parseFloat(a.summoney) - parseFloat(b.summoney);
            });
          }
        }
        this.dragonTigerLists = resource;

        //交易日期
        if (type=='date') {
          this.$nextTick(function() {
            $('td.col').removeClass('col');
            $('td.date').addClass('col');
          });
        }
        //成交价
        if (type=='cjj') {
          this.$nextTick(function() {
            $('td.col').removeClass('col');
            $('td.cjj').addClass('col');
          });
        }
        if (type=='ratio') {
          this.$nextTick(function() {
            $('td.col').removeClass('col');
            $('td.ratio').addClass('col');
          });
        }
        //成交量
        if (type=='quantity') {
          this.$nextTick(function() {
            $('td.col').removeClass('col');
            $('td.quantity').addClass('col');
          });
        }
        //成交额
        if (type=='summoney') {
          this.$nextTick(function() {
            $('td.col').removeClass('col');
            $('td.summoney').addClass('col');
          });
        }

        this.$nextTick(function () {
          if (this.showTopRow != '') {
            $('.top5-detail-' + this.showTopRow).show();
          }
        });
      },
      isShow: function(num) {
        if (!num) { return 3; }

        num = parseFloat(num);
        if (num === 0) {
          return 3;
        } else if (num > 0) {
          return 1;
        } else if (num < 0) {
          return 2;
        }
      },
      viewStockTop2: function(date, reason, index) {
        if (!date) { return; }

        this.buyTop5 = [];
        this.sellTop5 = [];
        this.showTopRow = index;

        let query = {};
        query.companycode = this.companycode;
        query.date = date;
        query.reason = reason;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/company/stocktoptop5'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            let resource = response.data;
            for (let item of resource) {
              if (item.isbuytop5) {
                item.jmr = (item.buy - item.sell);
                this.buyTop5.push(item);
              }
              if (item.isselltop5) {
                item.jmr = (item.buy - item.sell);
                this.sellTop5.push(item);
              }
            }

            // this.showTopFive = true;
            this.$nextTick(function() {
              $('.top5-detail').hide();
              $('.top5-detail-' + index).show();
            });
          } else {
            alert(response.description);
          }

        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },
      hideStockTop: function(index) {
        $('.top5-detail-' + index).hide();
        this.showTopRow = '';
      },
      hideFundTop5: function(e) {
        let _con = $('.interval-main')
        // 判断点击是否发生在空白区域
        if (!_con.is(e.target) && _con.has(e.target).length === 0) {
          this.showTopFive = false;
        }
      },
      showDateDropmemu: function() {
        this.dateDropmenu = this.dateDropmenu ? false : true;
      },
      clickDropmenu: function() {
        this.dateDropmenu = false;
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }
</style>


/** WEBPACK FOOTER **
 ** StockTops.vue?a9066084
 **/